import { apiGet, apiPost, apiPut } from '../utils/apiClient';

export default class InstancesIntegration {
    listInstances(botApiUrl, templateId, authToken) {
        return apiGet(`${botApiUrl}/bot-template/${templateId}/instance`, { authToken });
    }

    createEmptyInstance() {
        return {
            id: null,
            instanceTitle: 'New Instance',
            agendaAPI: 'localhost:7443/agenda-api',
            agendaAPIVersion: 'v1',
            conversationAPI: 'localhost:8443/conversation-api',
            conversationAPIVersion: 'v1',
            rateLimiterConversation: '5',
            dialogflowProject: 'my-template',
            dialogflowCredentialsURL: 'file:///credentials/my-template-01.json',
            dialogflowEnvironment: '',
            dialogflowUsername: '',
            dialogFlowLanguage: '',
            botType: 'GRÁTIS',
            currentAvailableBotSlots: 100,
            currentNumberOfBots: 0,
            whatsappBaseIntegration: 'localhost:3333/whatsapp',
        };
    }

    getLanguage() {
        return apiGet(`${process.env.REACT_APP_JSON_URL}/language.json`)
            .then((d) => d.data);
    }

    saveInstance(botApiUrl, templateInstance, templateId, authToken) {
        if (templateInstance.id) {
            return apiPut(
                `${botApiUrl}/bot-template/${templateId}/instance/${templateInstance.id}`,
                templateInstance,
                { authToken }
            );
        }

        return apiPost(
            `${botApiUrl}/bot-template/${templateId}/instance`,
            templateInstance,
            { authToken }
        );
    }
}
